(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cjy-holiday-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cjy-holiday-hero')) {
  customElements.define('cjy-holiday-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2 || this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.current = 0;
      this.visible = true;
      this.hovering = false;
      this.focused = false;
      this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(window.Shopify?.designMode);
      this.controls = this.querySelector('.cjy-holiday__controls');
      this.controls.hidden = false;
      this.updatePause();
      this.querySelector('[data-prev]').addEventListener('click', () => this.manual(this.current - 1), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.manual(this.current + 1), {signal});
      this.querySelectorAll('[data-go]').forEach(button => button.addEventListener('click', () => this.manual(Number(button.dataset.go)), {signal}));
      this.querySelector('[data-pause]').addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, {signal});
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.schedule(); } }, {signal});
      this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
      this.addEventListener('keydown', event => { if (event.target.matches('input, textarea, select')) return; if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.manual(this.current + (event.key === 'ArrowRight' ? 1 : -1)); } }, {signal});
      this.addEventListener('touchstart', event => { if (event.touches.length === 1) this.touch = {x: event.touches[0].clientX, y: event.touches[0].clientY}; }, {signal, passive: true});
      this.addEventListener('touchend', event => { if (!this.touch || !event.changedTouches[0]) return; const dx = event.changedTouches[0].clientX - this.touch.x; const dy = event.changedTouches[0].clientY - this.touch.y; this.touch = null; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.manual(this.current + (dx < 0 ? 1 : -1)); }, {signal, passive: true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      document.addEventListener('shopify:block:select', event => { const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId); if (index >= 0) this.manual(index); }, {signal});
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold: 0.15});
      this.observer.observe(this);
      this.schedule();
    }
    manual(index) { this.paused = true; this.show(index, true); this.updatePause(); this.schedule(); }
    show(index, announce = false) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
      this.querySelectorAll('[data-go]').forEach((button, i) => { if (i === this.current) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); });
      if (announce) this.querySelector('[data-status]').textContent = this.slides[this.current].querySelector('h1, h2').textContent;
    }
    updatePause() {
      this.querySelector('[data-pause]').setAttribute('aria-pressed', String(this.paused));
      this.querySelector('[data-state-running]').hidden = this.paused;
      this.querySelector('[data-state-paused]').hidden = !this.paused;
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && this.visible && !this.hovering && !this.focused && !document.hidden) this.timer = setTimeout(() => { this.show(this.current + 1); this.schedule(); }, 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cjy-product-page"] && !Shopify.designMode) return;
  try {
    

function setupCjyProducts(root=document){
  root.querySelectorAll('[data-cjy-pdp]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    section.querySelectorAll('[data-photo-src]').forEach(thumb=>thumb.addEventListener('click',()=>{
      const image=section.querySelector('.cjy-pdp__main-image');
      if(!image)return;
      image.removeAttribute('srcset');image.src=thumb.dataset.photoSrc;
      section.querySelectorAll('[data-photo-src]').forEach(item=>item.setAttribute('aria-pressed',String(item===thumb)));
    }));
    const form=section.querySelector('form');
    if(!form)return;
    const quantity=section.querySelector('[data-quantity]');
    const variant=section.querySelector('[data-variant]');
    const button=section.querySelector('[data-add-button]');
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:section.dataset.currency||'USD'}).format(cents/100);
    let switching=false;
    function update(){
      const option=variant.selectedOptions[0];
      const price=Number(option?.dataset.price)||0;
      const units=Number(option?.dataset.units)||Number(section.dataset.unitCount)||0;
      const count=Math.max(1,Number(quantity.value)||1);
      section.querySelector('[data-total-price]').textContent=money(price*count);
      section.querySelector('[data-total-pieces]').textContent=units?section.dataset.pieceLabel+': '+String(units*count):'';
      section.querySelector('[data-price]').textContent=money(price);
      const perPiece=section.querySelector('[data-piece-price]');
      if(perPiece&&units)perPiece.textContent=(option.dataset.label||option.textContent.split(' — ')[0])+' · '+money(price/units)+' '+section.dataset.perPiece;
      const included=section.querySelector('[data-included]');
      if(included&&units)included.textContent=included.dataset.template.replace('__COUNT__',String(units));
      const row=section.querySelector('[data-sku-row]');
      if(row){row.hidden=!option.dataset.sku;section.querySelector('span[data-sku]').textContent=option.dataset.sku||'';}
      section.querySelector('label[for="'+quantity.id+'"]').textContent=units>1?section.dataset.packLabel:section.dataset.quantityLabel;
      const available=option?.dataset.available==='true';
      button.disabled=!available||switching;button.textContent=available?button.dataset.addLabel:button.dataset.soldLabel;
    }
    async function choosePack(){
      const option=variant.selectedOptions[0];
      if(option.dataset.productId===section.dataset.productId){
        update();
        const nextUrl=new URL(window.location.href);nextUrl.searchParams.set('variant',option.value);history.replaceState({},'',nextUrl);
        return;
      }
      if(switching)return;
      switching=true;button.disabled=true;variant.disabled=true;
      const status=section.querySelector('[data-pack-loading]');status.hidden=false;status.textContent=section.dataset.loadingLabel;
      const productUrl=new URL(option.dataset.productUrl,window.location.origin);
      for(const name of ['preview_theme_id','_fd','pb'])if(new URL(window.location.href).searchParams.has(name))productUrl.searchParams.set(name,new URL(window.location.href).searchParams.get(name));
      try{
        const renderUrl=new URL(productUrl);renderUrl.searchParams.set('section_id',section.dataset.sectionId);
        const response=await fetch(renderUrl,{headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Pack could not be loaded');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=doc.querySelector('[data-cjy-pdp]');
        if(!fresh||fresh.dataset.productId!==option.dataset.productId)throw new Error('Pack response mismatch');
        const oldWrapper=section.closest('[id^="shopify-section-"]');
        const newWrapper=fresh.closest('[id^="shopify-section-"]');
        if(!oldWrapper||!newWrapper)throw new Error('Pack wrapper missing');
        oldWrapper.replaceWith(newWrapper);history.pushState({cjyPack:true},'',productUrl);
        document.title=fresh.querySelector('h1').textContent+' – '+document.title.split(' – ').pop();
        setupCjyProducts();fresh.querySelector('[data-variant]')?.focus({preventScroll:true});
      }catch(error){window.location.assign(productUrl);}
    }
    quantity.addEventListener('input',update);variant.addEventListener('change',choosePack);
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(switching)return;
      if(!Number.isInteger(Number(quantity.value))||Number(quantity.value)<1){quantity.reportValidity();return;}
      const errors=section.querySelector('[data-cart-error]');errors.hidden=true;button.disabled=true;
      const data=new FormData(form);const properties={};
      for(const [name,value]of data.entries()){const match=name.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=value;}
      try{
        const response=await fetch(section.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:data.get('id'),quantity:Number(data.get('quantity')),properties})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||response.statusText);
        window.location.assign(section.dataset.cartUrl);
      }catch(error){errors.textContent=error.message;errors.hidden=false;update();}
    },true);
    update();
  });
}
setupCjyProducts();
document.addEventListener('shopify:section:load',event=>setupCjyProducts(event.target));
window.addEventListener('popstate',()=>{if(document.querySelector('[data-cjy-pdp]'))window.location.reload();});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
